var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$search[_vm.data._uid])?_c('SearchWrapper',{key:_vm.data._uid,attrs:{"parentId":_vm.data._uid,"searchContext":_vm.$search[_vm.data._uid]}},[(_vm.data.sections)?[_vm._l((_vm.data.sections),function(widget){return [_vm._t("default",null,{"data":widget})]})]:_vm._e()],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }